//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
let d=[[[0,"Action",1,0],[0,"BoardPropertiesFile",1,0],[0,"ComponentSimulationDataFile",1,0],[0,"CreateHoleConstraints",1,0],[0,"CreateIdealizedPart",1,0],[0,"ElementStartLabel",1,0],[0,"FemFile",1,0],[0,"FemName",1,0],[0,"FemNumber",1,0],[0,"FemRevision",1,0],[0,"Folder",1,0],[0,"IPartFile",1,0],[0,"IPartName",1,0],[0,"IPartNumber",1,0],[0,"IPartRevision",1,0],[0,"NodeStartLabel",1,0],[0,"SimName",1,0],[0,"SimNumber",1,0],[0,"SimRevision",1,0],[0,"SimulationFile",1,0],[0,"SolutionType",1,0],[0,"UpdateType",1,0],[0,"UseBoardPropertiesFile",1,0],[0,"UseComponentSimulationData",1,0],[0,"UseEntityFilter",1,0]],[[[],"GetEntityFilter",{R_:{filter:"PcbExchange.EntityFilter"}},0,0],[["filter"],"SetEntityFilter",{},1,0],[["simNumber","simRevision","femNumber","femRevision","iPartNumber","iPartRevision"],"AssignPartNumberAndRevisions",{},0,0],[[],"EditComponentSimulationDatabase",{},0,0]],[]];
SPLM.PcbExchange.StructuralSolutionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.StructuralSolutionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PcbExchange.StructuralSolutionBuilder.SolutionTypeOption = Object.freeze({
    "LinearStatics" : "LinearStatics", "NormalModes" : "NormalModes"});

SPLM.PcbExchange.StructuralSolutionBuilder.ActionOption = Object.freeze({
    "CreateSolution" : "CreateSolution", "UpdateSolution" : "UpdateSolution"});

SPLM.PcbExchange.StructuralSolutionBuilder.UpdateOption = Object.freeze({
    "UpdateComponents" : "UpdateComponents", "UpdatePCB" : "UpdatePCB"});

export default SPLM;